import { render, staticRenderFns } from "./ProjectEditButton.vue?vue&type=template&id=d2e6384a&scoped=true&"
import script from "./ProjectEditButton.vue?vue&type=script&lang=ts&"
export * from "./ProjectEditButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectEditButton.vue?vue&type=style&index=0&id=d2e6384a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e6384a",
  null
  
)

export default component.exports